import { graphql, useStaticQuery } from "gatsby";

const filterExpiredEvents = event => {
  const now = Date.now();
  const end = new Date(event?.node?.frontmatter?.dateRange?.end).getTime();
  return end >= now;
};

const useGetRctpEvents = limit => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        limit: 100
        sort: { frontmatter: { dateRange: { start: ASC } } }
        filter: {
          frontmatter: {
            templateKey: { eq: "training-session" }
            draft: { ne: true }
          }
        }
      ) {
        edges {
          node {
            id
            frontmatter {
              title
              image
              link
              address
              dateRange {
                start
                end
              }
            }
          }
        }
      }
    }
  `);

  const { edges: events } = data.allMarkdownRemark;
  const filteredEvents = events.filter(filterExpiredEvents);
  const limitedEvents =
    typeof limit === "number" ? filteredEvents.slice(0, limit) : filteredEvents;

  return limitedEvents ?? [];
};

export default useGetRctpEvents;
